module.exports = __webpack_public_path__ + "img/rose-bowl_2.34c6e979.jpg";